import {
    getCard,
    listCards
} from './queries';
import {
    createCard,
    deleteCard,
    updateCard,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';
import {
    Card,
    CreateCard,
    DeleteCard,
    GetCard,
    ListCards,
    UpdateCard
} from "../types.ts";
import {generateClient} from "aws-amplify/api";


const client = generateClient();


export const fetchRecords = async (customerId: string, limit?: number, nextToken?: string) => {

    const response = await client.graphql<GraphQLQuery<ListCards>>(
        {
            query: listCards,
            variables: {
                filter: {
                    customerId: customerId
                },
                limit,
                nextToken,
            },
        });

    return response.data?.listCards;
};

export const fetch = async (customerId: string, id: string) => {

    const response = await client.graphql<GraphQLQuery<GetCard>>(
        {
            query: getCard,
            variables: {
                customerId: customerId,
                id: id
            },
        });
    return response.data?.getCard;
};

export const add = async (payload: object) => {

    const response = await client.graphql<GraphQLQuery<CreateCard>>(
        {
            query: createCard,
            variables: {
                input: payload
            },
        });

    return response.data?.createCard;
};

/**
 * FNP-918: the update payload is WHITELISTED to the API's Input type (§6).
 *
 * ⚠️ This previously read `delete record.created; delete record.updated;` and
 * sent the record itself. Two separate defects in three lines:
 *
 *  1. `delete` MUTATES THE CALLER'S OBJECT. The record handed in is the live
 *     Formik value or a React Query cache entry, so saving a card silently
 *     stripped `created`/`updated` from the copy the table was still rendering.
 *     `applications` shipped exactly this for months (FNP-996).
 *  2. Blacklisting is open-ended. Any field the API does not accept — anything
 *     added to the type later, or the derived `expiresAtSortKey` this module
 *     now attaches for sorting — rides along and the mutation fails on a field
 *     nobody chose to send.
 *
 * Building a NEW object from the fields UpdateCardInput declares fixes both.
 * Undefined keys are dropped rather than sent as nulls: AppSync treats an
 * explicit null as "clear this attribute".
 */
export const update = async (record: Card) => {

    const input: Record<string, unknown> = {
        id: record.id,
        customerId: record.customerId,
        name: record.name,
        expMonth: record.expMonth,
        expYear: record.expYear,
    };

    Object.keys(input)
          .forEach(key => {
              if (typeof input[key] === 'undefined') {
                  delete input[key];
              }
          });

    const response = await client.graphql<GraphQLQuery<UpdateCard>>(
        {
            query: (updateCard),
            variables: {input},
        });
    return response.data?.updateCard;
};

export const deleteRecord = async (customerId: string, id: string) => {

    const response = await client.graphql<GraphQLQuery<DeleteCard>>(
        {
            query: (deleteCard),
            variables: {
                input: {
                    customerId: customerId,
                    id: id
                }
            },

        });
    return response.data?.deleteCard;
};
